import React from 'react'
import HeaderRow from './components/HeaderRow'
import HeaderCell from './components/HeaderCell'
import Row from './components/Row'
import Cell from './components/Cell'
import Body from './components/Body'
import classNames from 'classnames'

type PropTypes = {
  className?: string,
  children: React.ReactNode
}

const ProductConfigurationTable = ({ className, children }: PropTypes) => {
  return (
    <table className={classNames('w-full table-fixed border-separate border-spacing-0 border-gray-400 border-t text-sm leading-[14px] text-gray-700', className)}>
      {children}
    </table>
  )
}

ProductConfigurationTable.HeaderRow = HeaderRow
ProductConfigurationTable.HeaderCell = HeaderCell
ProductConfigurationTable.Body = Body
ProductConfigurationTable.Row = Row
ProductConfigurationTable.Cell = Cell

export default ProductConfigurationTable
